<template>
  <div class="w-full p-1  rounded">
    <div v-for="(row , i) of rows" :key="i" class="flex justify-center flex-wrap">
      <div
        class="w-3 h-3 border border-gray-600 m-px hover:border-blue-600"
        :class="[
         i<hover.rows && j<hover.cols ? 'border border-teal-400':'',
         i<selected.rows && j<selected.cols ? 'bg-teal-600':''
         ]"
        v-for="(col , j) of cols"
        :key="j"
        @mouseover="hoverIndex(i+1,j+1)"
        @click="select()"
      ></div>
    </div>
    <div class="text-gray-100 p-1 flex">
      <VInput :name="'Rows '+hover.rows" type="number" v-model="selected.rows" mode="dark" />
      <VInput :name="'Columns '+hover.cols" type="number" v-model="selected.cols" mode="dark"  />
    </div>
  </div>
</template>

<script>
export default {
  name: "VGridDropDown",
  props: {},
  data() {
    return {
      rows: 21,
      cols: 21,
      hover: {
        cols: 2,
        rows: 2
      },
      selected: { cols: 12, rows: 2 }
    };
  },
  computed: {},
  methods: {
    hoverIndex(rows, cols) {
      this.hover = { rows, cols };
    },
    select() {
      this.selected = this.hover;
      this.$emit("change", this.selected);
    }
  }
};
</script>

<style>
</style>